import React from 'react';

export default () => {
    return (
        <div className='Loading'>
            <div className='lds-ellipsis'>
                <div />
                <div />
                <div />
                <div />
            </div>
        </div>
    );
};
